import {mapActions} from 'vuex'

var list = {
  data() {
    return {
      list: {
        pagination: {
          page: 1,
          rowsPerPage: 10,
          totalItems: 0,
          current_page: 0,
          per_page: 0,
          last_page: 0,
        },
        items: [],
      },
      isLoading: false
    }
  },
  watch: {
    'list.pagination.page'() {
      this.load()
    },
    'list.pagination.rowsPerPage'() {
      this.load()
    }
  },
  methods: {
    ...mapActions(['queue']),
    load() {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        if (this.timeout) {
          clearTimeout(this.timeout)
        }
        this.timeout = setTimeout(() => {

          let params = {
            page: this.list.pagination.page,
            limit: this.list.pagination.rowsPerPage
          }

          if (typeof this.collectSort === "function") {
            params = this.collectSort(params)
          }

          if (typeof this.collectFilter === "function") {
            params = this.collectFilter(params)
          }
          this.getData(params)
            .then(data => {
              this.queue(data);
              resolve(data);
              this.isLoading = false
            })
            .catch(error => {
              reject(error);
              this.isLoading = false
            });
        }, 400)
      })

    },
    getData(params) {
      return this.getList(params).then((response) => {
        this.list.items = this.onLoadTransform(response.data.data ? response.data.data : response.data)
        this.list.pagination.totalItems = response.data.total ? response.data.total : response.data.length
        this.list.pagination.current_page = response.data.current_page
        this.list.pagination.per_page = response.data.per_page
        this.list.pagination.last_page = response.data.last_page
      })
    },
    getList(params) {
      return this.api.list(params)
    },
    onLoadTransform(data) {
      return data
    }
  }
}

export default list
